
import React from 'react';
import swal from "sweetalert";
import FusionCharts from 'fusioncharts/core';
import FusionMaps from 'fusioncharts/maps';
import Mexico from 'fusionmaps/maps/es/fusioncharts.mexico';
import FusionTheme from 'fusioncharts/themes/es/fusioncharts.theme.fusion'

FusionCharts.addDep(FusionMaps);
FusionCharts.addDep(Mexico);
FusionCharts.addDep(FusionTheme);

class MapaRedencion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        let self = this;
    }

    componentDidMount() {
        let self = this;

        let month_url = "";

        switch (month) {
            case "enero":
                month_url = "01";
                break;
            case "febrero":
                month_url = "02";
                break;
            case "marzo":
                month_url = "03";
                break;
            case "abril":
                month_url = "04";
                break;
            case "mayo":
                month_url = "05";
                break;
            case "junio":
                month_url = "06";
                break;
            case "julio":
                month_url = "07";
                break;
            case "agosto":
                month_url = "08";
                break;
            case "septiembre":
                month_url = "09";
                break;
            case "octubre":
                month_url = "10";
                break;
            case "noviembre":
                month_url = "11";
                break;
            case "diciembre":
                month_url = "12";
                break;
        }

        if (year >= 2023) {
            axios.get('/api/reports/' + month_url + '/' + year + '/map')
            .then(response => {
                let map = response.data;
                let data = [];
                let menor = 0;
                let mayor = 0;

                mayor = parseInt(map[0].Cupones);
                menor = mayor;

                for (let i = 1; i < map.length; i++) {
                    let data_json = {
                        id: map[i].ID_FUSION,
                        value: map[i].Cupones
                    };
                    data.push(data_json);

                    mayor = parseInt(map[i].Cupones) > mayor ? parseInt(map[i].Cupones): mayor;
                    menor = menor > parseInt(map[i].Cupones) ? parseInt(map[i].Cupones): menor;
                }

                let arr = new FusionCharts({
                    type: 'maps/mexico',
                    renderAt: 'map-chart123',
                    width: '100%',
                    height: '85%',
                    dataFormat: 'json',
                    dataSource: {
                        "chart": {
                            "entityFillHoverColor": "#ff7514",
                            "numberPrefix": "",
                            "theme": "fusion",
                            "showLegend": "1",
                            "borderThickness": "0",
                            "showCanvasBorder": "0",
                            "showValues": "1",
                            "showmarkerlabels": "1",
                        },
                        "colorrange": {
                            "minvalue": menor.toString(),
                            "startlabel": "Bajo",
                            "endlabel": "Alto",
                            "code": "#2471A3",
                            "gradient": "1",
                            "color": [{
                                "maxvalue": mayor.toString(),
                                "displayvalue": "Prom.",
                                "code": "#DAF7A6"
                            }, {
                                "maxvalue": mayor.toString(),
                                "code": "#4EEE12"
                            }]
                        },
                        "data": data
                    }
                }).render();
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });
        }


    }

    render() {
        let random = Math.random();
        return (
            <div id={"" + random}>
                <div id='map-chart123'></div>
            </div>
        );
    }
}

export default MapaRedencion;


// WEBPACK FOOTER //
// ./resources/assets/react/dashboard/MapaRedencion.jsx